/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationRecordValue
 */
export interface EvaluationRecordValue {
    /**
     * Required in batch mode: canonical evaluation series UUID
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    evaluationSeriesId?: string;
    /**
     * FLOAT64 value; non-finite values serialize as NaN, Infinity or -Infinity strings
     * @type {number}
     * @memberof EvaluationRecordValue
     */
    floatValue?: number;
    /**
     * 
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    metricName: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    recordName: string;
    /**
     * Required in batch mode: canonical run UUID
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    runId?: string;
    /**
     * Required in batch mode: zero-based index in request sources
     * @type {number}
     * @memberof EvaluationRecordValue
     */
    sourceIndex?: number;
    /**
     * STRING value, including the empty string
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    stringValue?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationRecordValue
     */
    type: EvaluationRecordValueTypeEnum;
}


/**
 * @export
 */
export const EvaluationRecordValueTypeEnum = {
    Float64: 'FLOAT64',
    String: 'STRING'
} as const;
export type EvaluationRecordValueTypeEnum = typeof EvaluationRecordValueTypeEnum[keyof typeof EvaluationRecordValueTypeEnum];


/**
 * Check if a given object implements the EvaluationRecordValue interface.
 */
export function instanceOfEvaluationRecordValue(value: object): value is EvaluationRecordValue {
    if (!('metricName' in value) || value['metricName'] === undefined) return false;
    if (!('recordName' in value) || value['recordName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function EvaluationRecordValueFromJSON(json: any): EvaluationRecordValue {
    return EvaluationRecordValueFromJSONTyped(json, false);
}

export function EvaluationRecordValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationRecordValue {
    if (json == null) {
        return json;
    }
    return {
        
        'evaluationSeriesId': json['evaluationSeriesId'] == null ? undefined : json['evaluationSeriesId'],
        'floatValue': json['floatValue'] == null ? undefined : json['floatValue'],
        'metricName': json['metricName'],
        'recordName': json['recordName'],
        'runId': json['runId'] == null ? undefined : json['runId'],
        'sourceIndex': json['sourceIndex'] == null ? undefined : json['sourceIndex'],
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
        'type': json['type'],
    };
}

export function EvaluationRecordValueToJSON(value?: EvaluationRecordValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'evaluationSeriesId': value['evaluationSeriesId'],
        'floatValue': value['floatValue'],
        'metricName': value['metricName'],
        'recordName': value['recordName'],
        'runId': value['runId'],
        'sourceIndex': value['sourceIndex'],
        'stringValue': value['stringValue'],
        'type': value['type'],
    };
}

